import { instance } from '../instance';
import type { GraduateDto } from './graduate.dto';

export const getGraduateInfo = async (applicantId: string) => {
  try {
    const response = await instance.get<GraduateDto>(
      `graduate/info/${applicantId}`,
    );
    return response.data;
  } catch (e) {
    console.error('수료생 조회 에러', e);
    return e.response.data;
  }
};

export const getApplicantId = async (onlineUserId: string, round: string) => {
  try {
    const response = await instance.get<GraduateDto>(
      `graduate/getApplicantId/${onlineUserId}/${round}`,
    );
    return response.data;
  } catch (e) {
    console.error('수료생 Applicant Id 조회 에러', e);
    return e.response.data;
  }
};
